<template>
  <div
    v-infinite-scroll="load"
    :infinite-scroll-immediate="false"
    :infinite-scroll-disabled="disabled"
    :infinite-scroll-distance="100"
    style="overflow-y: auto; max-height: calc(100vh - 80px)"
  >
    <div class="r-container">
      <el-form inline class="form-box">
        <div>
          <el-form-item label="案例类型">
            <el-select v-model="type" @change="getDraft(1)">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="全屋案例" :value="3"></el-option>
              <el-option label="自定义案例" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="案例标题" class="flex" style="margin-right: 0">
            <el-input
              class="search-title"
              v-model="title"
              placeholder="全部"
              @blur="getDraft(1)"
              suffix-icon="el-icon-search"
              @keyup.enter.native="getDraft(1)"
              style="width: 628px"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div v-if="list.length">
        <ProjectCard
          v-for="item in list"
          :key="item.id"
          :item="item"
          :isDraft="true"
        ></ProjectCard>
        <p class="t-center" v-if="isLoading">加载中...</p>
        <p class="t-center" v-if="noMore">没有更多了</p>
      </div>
      <Empty v-if="!isLoading && !title && !list.length"></Empty>
      <SearchEmpty v-if="title && !list.length"></SearchEmpty>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import Empty from "@/components/Empty";
import SearchEmpty from "@/components/SearchEmpty";
import ProjectCard from "@/components/ProjectCard";
import { fetchDraft } from "@/api/index";
export default {
  data() {
    return {
      isLoading: true,
      type: -1,
      title: "",
      list: [],
      page: 1,
      total: 0,
    };
  },
  computed: {
    noMore() {
      return this.list.length >= this.total;
    },
    disabled() {
      return this.isLoading || this.noMore;
    },
  },
  components: {
    Banner,
    ProjectCard,
    Empty,
    SearchEmpty,
  },
  created() {
    this.getDraft(1);
  },
  methods: {
    async getDraft(page) {
      this.isLoading = true;
      if (page) {
        this.page = 1;
      }
      try {
        const res = await fetchDraft({
          type: this.type,
          page: this.page,
          title: this.title,
        });
        this.list =
          page === 1 ? res.data.list : this.list.concat(res.data.list);
        this.total = res.data.total;
      } finally {
        this.isLoading = false;
      }
    },
    load() {
      this.page++;
      this.getDraft();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-title {
  width: 660px;
}
.r-container {
  margin: 40px auto 80px auto;
  width: 1100px;
  min-height: calc(100vh - 200px);
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
  .form-box {
    display: flex;
    justify-content: space-between;
  }
  ::v-deep.el-input__suffix {
    cursor: pointer;
  }
  .t-center {
    text-align: center;
    margin-top: 20px;
  }
}
</style>